import { styled } from 'styled-components'
import { THUMBNAIL_RENDER_SIZE_PX } from './consts'

export const Stack = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const FrontTile = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`

export const BackTile = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  opacity: 0.5;
  transform: translate(-4%, 1%) rotate(-8deg);
  transform-origin: center;
  pointer-events: none;
`

export const ThumbnailWrapper = styled.div`
  width: ${THUMBNAIL_RENDER_SIZE_PX}px;
  height: ${THUMBNAIL_RENDER_SIZE_PX}px;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`
